import React from 'react';
import Skeleton from 'react-loading-skeleton';
import PropTypes from 'prop-types';

const LocationLoader = ({ width, height }) => {
  return (
    <div>
      <Skeleton
        height={25 || height}
        width={100 || width}
        // style={{ background: '#edfafa' }}
      />
    </div>
  );
};

export default LocationLoader;

LocationLoader.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

LocationLoader.defaultProps = {
  width: 0,
  height: 0,
};
